var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component",scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(){return [_vm._t(name)]},proxy:true}})],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }